import axios from 'axios';

/**
 * Email API endpoint (Vercel serverless function)
 */
const EMAIL_API_URL = '/api/send-email';

/**
 * Book an appointment
 * @param {Object} appointmentData - Appointment details
 * @returns {Promise} - API response
 */
export const bookAppointment = async (appointmentData) => {
  try {
    const response = await axios.post(EMAIL_API_URL, {
      formType: 'appointment',
      ...appointmentData,
    });

    if (response.data.success) {
      return {
        success: true,
        message: 'Your appointment has been submitted successfully! We will contact you shortly to confirm.',
        data: response.data,
      };
    } else {
      throw new Error(response.data.message || 'Failed to submit appointment');
    }
  } catch (error) {
    console.error('Appointment submission error:', error);
    throw new Error(error.response?.data?.message || error.message || 'Failed to submit appointment. Please try again.');
  }
};

/**
 * Submit contact form
 * @param {Object} contactData - Contact form details
 * @returns {Promise} - API response
 */
export const submitContactForm = async (contactData) => {
  try {
    const response = await axios.post(EMAIL_API_URL, {
      formType: 'contact',
      ...contactData,
    });

    if (response.data.success) {
      return {
        success: true,
        message: 'Your message has been sent successfully! We will get back to you soon.',
        data: response.data,
      };
    } else {
      throw new Error(response.data.message || 'Failed to send message');
    }
  } catch (error) {
    console.error('Contact form submission error:', error);
    throw new Error(error.response?.data?.message || error.message || 'Failed to send message. Please try again.');
  }
};

/**
 * Format phone number for WhatsApp link
 * @param {string} phone - Phone number
 * @returns {string} - Formatted phone number
 */
export const formatWhatsAppNumber = (phone) => {
  // Remove all non-numeric characters
  let cleaned = phone.replace(/\D/g, '');
  
  // Ensure it starts with country code
  if (cleaned.startsWith('0')) {
    cleaned = '92' + cleaned.substring(1);
  } else if (!cleaned.startsWith('92')) {
    cleaned = '92' + cleaned;
  }
  
  return cleaned;
};

/**
 * Generate WhatsApp link with pre-filled message
 * @param {Object} appointmentData - Appointment details
 * @returns {string} - WhatsApp link
 */
export const generateWhatsAppBookingLink = (appointmentData) => {
  const { name, phone, service, date, time } = appointmentData;
  
  const message = encodeURIComponent(
    `Hello, I would like to book an appointment.\n\n` +
    `Name: ${name}\n` +
    `Phone: ${phone}\n` +
    `Service: ${service}\n` +
    `Preferred Date: ${date}\n` +
    `Preferred Time: ${time}\n\n` +
    `Please confirm my appointment. Thank you!`
  );
  
  return `https://wa.me/923000478311?text=${message}`;
};
